<template>
	<!-- sm md lg xl xxl -->
	<div class="list-card">
		<div class="main">
			<div class="container">
				<div class="row">
					<div class="img col-sm-12 col-lg-3 mb-2">
						<template v-if="detailData.cover_image">
							<img :src="detailData.cover_image" width="100%" />
						</template>
						<template v-else>
							<img src="../assets/images/default.jpg" width="100%" />
						</template>
					</div>
					<div class="content col-sm-12 col-lg-9">
						<div class="title">
							<div class="row justify-content-between align-items-center">
								<div class="col-10 text-base-color-1 fs-5">
									<strong>{{ detailData.project_name }}{{ detailData.version }}</strong>
								</div>
								<div class="options col-auto">
									<a-popconfirm title="确定删除项目?" ok-text="确定" cancel-text="取消" @confirm="handleDelete">
										<div class="option text-primary-color fs-7">删除</div>
									</a-popconfirm>
									<template v-if="detailData.create_num < 2 && detailData.rate == 100">
										<a-popconfirm title="确定重新生成?" ok-text="确定" cancel-text="取消" @confirm="handleAgain">
											<div class="option text-primary-color fs-7">重新生成</div>
										</a-popconfirm>
									</template>
									<template v-else>
										<div class="option text-disabled-color fs-7">重新生成</div>
									</template>
								</div>
							</div>
						</div>
						<div class="tags">
							<div class="tag text-base-color-1 fs-8">{{ detailData.id }}</div>
							<div class="tag text-base-color-1 fs-8">{{ detailData.company }}</div>
							<div class="tag text-base-color-1 fs-8">{{ typeEnum[detailData.device_type] }}</div>
						</div>
						<div class="files">
							<div class="row g-2">
								<div class="col-sm-6 col-lg-3">
									<div class="file">
										<div class="top text-primary-color fs-8 mb-1">
											<img src="../assets/images/list-item-01.png" />
											申请表
										</div>
										<div class="bot">
											<div class="status">
												<div class="piont" :class="{ 'warning-piont': !detailData.application_form_url }"></div>
												<div class="text-base-color-2 fs-8">{{ detailData.application_form_url ? '已完成' : '生成中' }}</div>
											</div>
											<div class="download" v-if="detailData.application_form_url">
												<div class="item" @click="handleDownload(1)">
													<img src="../assets/images/list-item-download-icon.png" />Txt
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-sm-6 col-lg-3">
									<div class="file">
										<div class="top text-primary-color fs-8 mb-1">
											<img src="../assets/images/list-item-02.png" />
											操作手册
										</div>
										<div class="bot">
											<div class="status">
												<div class="piont" :class="{ 'warning-piont': !detailData.specification_url_info }">
												</div>
												<div class="text-base-color-2 fs-8">{{ detailData.specification_url_info?.pdf_url ? '已完成' :
													'生成中' }}</div>
											</div>
											<div class="download" v-if="detailData.specification_url_info">
												<div class="item" @click="handleDownload(2)" v-if="detailData.specification_url_info?.pdf_url">
													<img src="../assets/images/list-item-download-icon.png" />PDF
												</div>
												<div class="item" @click="handleDownload(3)" v-if="detailData.specification_url_info?.word_url">
													<img src="../assets/images/list-item-download-icon.png" />Word
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-sm-6 col-lg-3">
									<div class="file">
										<div class="top text-primary-color fs-8 mb-1">
											<img src="../assets/images/list-item-03.png" />
											代码文档
										</div>
										<div class="bot">
											<div class="status">
												<div class="piont" :class="{ 'warning-piont': !detailData.code_document_url_info }">
												</div>
												<div class="text-base-color-2 fs-8">{{ detailData.code_document_url_info?.pdf_url? '已完成' : '生成中'
												}}</div>
											</div>
											<div class="download" v-if="detailData.code_document_url_info">
												<div class="item" @click="handleDownload(4)" v-if="detailData.code_document_url_info?.pdf_url">
													<img src="../assets/images/list-item-download-icon.png" />PDF
												</div>
												<div class="item" @click="handleDownload(5)" v-if="detailData.code_document_url_info?.word_url">
													<img src="../assets/images/list-item-download-icon.png" />Word
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="col-sm-6 col-lg-3" v-if="detailData.device_type == 1">
									<div class="file">
										<div class="top text-primary-color fs-8 mb-1">
											<img src="../assets/images/list-item-03.png" />
											真实可运行程序
										</div>
										<div class="bot">
											<div class="status">
												<template v-if="!detailData.pay_demon_info.create_status">
													<template v-if="detailData.pay_demon_info.is_pay">
														<div class="piont warning-piont"></div>
														<div class="text-base-color-2 fs-8"><span style="color: #ff7834;">生成中</span></div>
													</template>
													<template v-else>
														<div class="text-base-color-2 fs-8">
															<span style="color: #ff7834;">￥20.0</span>
														</div>
													</template>
												</template>
												<template v-else-if="detailData.pay_demon_info.create_status == 2">
													<div class="text-base-color-2 fs-8">
														<span style="color: #ff7834;">{{ formatTimeDiff(detailData.pay_demon_info.expire_time *
															1000, new Date().getTime()) }}</span>
													</div>
												</template>
												<template v-else>
													<div class="piont warning-piont"></div>
													<div class="text-base-color-2 fs-8">{{ demoEnum[detailData.pay_demon_info.create_status] }}
													</div>
												</template>
											</div>
											<div class="download" v-if="detailData.rate==100">
												<div class="item item-pay" @click="handlePay"
													v-if="!detailData.pay_demon_info.create_status && !detailData.pay_demon_info.is_pay">
													支付生成
												</div>
												<div class="item" @click="hanldeDownloadDemo"
													v-if="detailData.pay_demon_info.create_status == 2">
													<img src="../assets/images/list-item-download-icon.png" />下载
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="footer">
			<a-progress :percent="detailData.rate" stroke-color="#38B06C" />
		</div>
		<demo-dialog ref="demoDialogRef" @completed="handleCompleted"></demo-dialog>
	</div>

</template>

<script>
import { getOrderDetailApi, againCreatetOrderApi } from '@/api/soft'
import DemoDialog from '@/components/DemoDialog.vue';

export default {
	name: 'ListCard',
	props: {
		itemData: Object
	},
	components: {
		DemoDialog
	},
	data() {
		return {
			detailData: {},
			typeEnum: {
				1: 'PC,Web,平板',
				3: '小程序',
				4: '安卓',
				5: 'IOS'
			},
			demoEnum: {
				0: '待生成',
				1: '生成中',
				2: '已生成',
				3: '成失败'
			}
		}
	},
	created() {
		this.getDetail()
	},
	methods: {
		// 订单 详情
		async getDetail() {
			const res = await getOrderDetailApi(this.itemData.id)
			if (res.code == 0) {
				this.detailData = res.data
				const rate = res.data.rate
				if (!(rate == 100 && !res.data.pay_demon_info.is_pay)) {
					setTimeout(() => {
						this.getDetail()
					}, 20000)
				}
			} else {
				this.$message.error(res.msg)
			}
		},
		// 订单 删除
		handleDelete() {
			this.$emit('delete', this.itemData.id)
		},
		// 订单 重新生成
		async handleAgain() {
			const res = await againCreatetOrderApi({
				id: this.itemData.id
			})
			if (res.code == 0) {
				this.$message.success('重新生成成功')
				this.getDetail()
			} else {
				this.$message.error(res.msg)
			}
		},
		// 下载
		handleDownload(type) {
			let url = ''
			let typeName = ''
			switch (type) {
				case 1:
					url = this.detailData.application_form_url
					typeName = '申请表.txt'
					break;
				case 2:
					url = this.detailData.specification_url_info.pdf_url
					typeName = '操作手册.pdf'
					break;
				case 3:
					url = this.detailData.specification_url_info.word_url
					typeName = '操作手册.docx'
					break;
				case 4:
					url = this.detailData.code_document_url_info.pdf_url
					typeName = '代码文档.pdf'
					break;
				case 5:
					url = this.detailData.code_document_url_info.word_url
					typeName = '代码文档.docx'
					break;
			}
			const name = this.detailData.project_name + '_' + this.detailData.version + '_' + typeName
			this.downloadFile(url, name)
		},
		// 下载demo
		hanldeDownloadDemo() {
			// 创建隐藏的a标签
			const link = document.createElement('a')
			link.href = this.detailData.pay_demon_info.demon_zip_url
			link.target = '_blank'
			link.style.display = 'none'

			// 添加到DOM并触发点击
			document.body.appendChild(link)
			link.click()

			// 清理
			document.body.removeChild(link)
		},
		// 下载文件方法
		// downloadFile(url, fileName) {
		// 	// 创建隐藏的a标签
		// 	const link = document.createElement('a')
		// 	link.href = url
		// 	link.download = fileName
		// 	link.target = '_blank'
		// 	link.style.display = 'none'

		// 	// 添加到DOM并触发点击
		// 	document.body.appendChild(link)
		// 	link.click()

		// 	// 清理
		// 	document.body.removeChild(link)
		// },
		// downloadFile(url, fileName) {
		// 	// 使用 fetch 获取文件内容
		// 	fetch(url)
		// 		.then(response => response.blob())
		// 		.then(blob => {
		// 			// 创建一个隐藏的 a 标签
		// 			const link = document.createElement('a');
		// 			link.href = URL.createObjectURL(blob);
		// 			link.download = fileName;
		// 			link.style.display = 'none';

		// 			// 添加到 DOM 并触发点击
		// 			document.body.appendChild(link);
		// 			link.click();

		// 			// 清理
		// 			document.body.removeChild(link);
		// 			URL.revokeObjectURL(link.href); // 释放 URL 对象
		// 		})
		// 		.catch(error => {
		// 			console.error('下载失败:', error);
		// 		});
		// },
		downloadFile(url, fileName) {
			const xhr = new XMLHttpRequest();
			xhr.open('GET', url, true);
			xhr.responseType = 'blob';
			// 如果需要携带认证信息
			// xhr.withCredentials = true;

			xhr.onload = function () {
				if (xhr.status === 200) {
					const blob = xhr.response;
					const link = document.createElement('a');
					const blobUrl = window.URL.createObjectURL(blob);

					link.href = blobUrl;
					link.download = fileName;
					link.style.display = 'none';

					document.body.appendChild(link);
					link.click();

					document.body.removeChild(link);
					window.URL.revokeObjectURL(blobUrl);
				} else {
					console.error('下载失败，状态码:', xhr.status);
				}
			};

			xhr.onerror = function () {
				console.error('网络错误，下载失败');
			};

			xhr.send();
		},
		// 充值
		handlePay() {
			this.$refs['demoDialogRef'].handleOpen(this.detailData.id)
		},
		// 充值 完成
		handleCompleted() {
			this.getDetail()
			// setTimeout(() => {
			//   if (this.isPay) {
			//     const createNum = this.$store.state.userInfo.create_rz_num
			//     if (createNum > 0) {
			//       this.handleSubmit()
			//     }
			//   }
			// }, 500)
		},
		// 格式化 倒计时
		formatTimeDiff(timestamp1, timestamp2) {
			// 计算时间差的绝对值（毫秒）
			const diffMs = Math.abs(timestamp1 - timestamp2);

			// 转换为分钟
			const totalMinutes = Math.floor(diffMs / (1000 * 60));

			// 计算小时和分钟
			const hours = Math.floor(totalMinutes / 60);
			const minutes = totalMinutes % 60;

			// 格式化输出
			let result = '';
			if (hours > 0) {
				result += `${hours}小时`;
			}
			if (minutes > 0 || hours === 0) {
				result += `${minutes}分钟`;
			}

			return result || '0分钟';
		}
	},
}
</script>
<style lang="scss" scoped>
.list-card {
	padding: 20px;
	background: linear-gradient(180deg, #FCFCFF 0%, #F8F9FF 100%);
	border-radius: 10px;
	border: 1px solid #ECECEC;

	.main {
		.content {
			.title {

				.options {
					display: flex;

					.option {
						cursor: pointer;

						&:not(:first-child) {
							margin-left: 10px;
						}
					}
				}
			}

			.tags {
				display: flex;
				flex-wrap: wrap;
				align-items: center;
				margin: 10px 0;

				.tag {
					margin-right: 10px;
					padding: 4px 8px;
					background-color: #F6F6F6;
					border-radius: 5px;
				}
			}

			.files {
				.file {
					padding: 4px 8px;
					background: #F5F6FF;
					border-radius: 5px;
					border: 1px solid #E1E4FF;

					.top {
						display: flex;
						align-items: center;

						img {
							margin-right: 4px;
							width: 13px;
							height: 13px;
						}
					}

					.bot {
						display: flex;
						justify-content: space-between;
						align-items: center;

						.status {
							display: flex;
							align-items: center;

							.piont {
								margin-right: 4px;
								width: 7px;
								height: 7px;
								border-radius: 50%;
								background-color: #44E07A;
							}

							.warning-piont {
								background-color: #FFBA92;
							}
						}

						.download {
							display: flex;
							align-items: center;

							.item {
								display: flex;
								justify-content: center;
								align-items: center;
								margin-left: 4px;
								padding: 2px 8px;
								border-radius: 4px;
								font-size: 12px;
								color: #fff;
								background-color: #5B66FF;
								cursor: pointer;

								img {
									margin-right: 2px;
									width: auto;
									height: 11px;
								}
							}

							.item-pay {
								background-color: #FF7834;
							}
						}
					}
				}
			}
		}
	}

	.footer {
		margin-top: 10px;
	}
}
</style>
